module.exports = __webpack_public_path__ + "05d5f8f5f4497067d253692c5e451c76.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logo.jpg
// module id = 85
// module chunks = 7